import { ChevronDown } from 'lucide-react';

const Dropdown = ({ name, value, onChange, placeholder, options, disabled }) => (
  <div className="select-wrapper">
    <select
      className="filter-base"
      name={name}
      value={value}
      onChange={onChange}
      disabled={disabled}
    >
      <option value="">{placeholder}</option>
      {options.map((opt) => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
    <ChevronDown className="select-icon" size={16} />
  </div>
);

export default Dropdown;
